import { useEffect, useState } from 'react';
import { NUMBER_FORMATS } from 'utils/formatters';
import { setUserPropertiesForPortals } from 'utils/urlUtilities';

import { fetchPriceRange, fetchScenarios } from '../../../services/pricing';
import { trackAmountCalculatorData } from '../utils/amountCalculatorTrack';

const DEFAULT_SCENARIOS = [
  {
    idx: 0,
    term_years: 10,
    label: 'Avg. appreciation',
    appreciation_percent: {
      annualized: true,
      value: 0.03,
    },
  },
  {
    idx: 1,
    term_years: 10,
    label: 'High appreciation',
    appreciation_percent: {
      annualized: true,
      value: 0.05,
    },
  },
  {
    idx: 2,
    term_years: 10,
    label: 'Large decline',
    appreciation_percent: {
      annualized: false,
      value: -0.1,
    },
  },
];

export default (homeValue, investmentAmount, setInvestmentAmount) => {
  const [isFetchingData, setIsFetchingData] = useState(false);
  const [minMax, setMinMax] = useState({ min: 0, max: 0 });
  const [error, setError] = useState(false);
  // const [scenarios, setScenarios] = useState([
  //   {
  //     calculated_appreciated_home_value: 0,
  //     crr_percent: 0,
  //     hometap_share: {
  //       percent: 0,
  //       dollars: 0,
  //     },
  //     homeowner_share: {
  //       percent: 0,
  //       dollars: 0,
  //     },
  //   },
  // ]);

  // const scenarioRequestBody = {
  //   scenarios: DEFAULT_SCENARIOS.map((scenario) => {
  //     scenario.starting_home_value = homeValue;
  //     scenario.investment_amount = investmentAmount;
  //     return scenario;
  //   }),
  // };

  const fetchAmountCalculatorData = async () => {
    try {
      const minMaxData = await fetchPriceRange({ home_value: homeValue });
      setMinMax(minMaxData.data);
      setInvestmentAmount(minMaxData.data.max);
      setUserPropertiesForPortals({
        'Amount Calculator Home Value': NUMBER_FORMATS.currency(homeValue, 0),
        'Amount Calculator Investment': NUMBER_FORMATS.currency(minMaxData.data.max, 0),
      });

      // const { data, status } = await fetchScenarios(scenarioRequestBody);
      // setScenarios(data.scenarios);
      setError(false);

      trackAmountCalculatorData('submit home value', {
        homeValue: homeValue,
        minMax: minMaxData.data,
        investmentAmount: minMaxData.data.max,
        // calculatorHomeValue: scenarios[0].starting_home_value,
        success: true,
        status_code: status,
      });
    } catch (error) {
      setError(true);
      trackAmountCalculatorData('submit home value', {
        homeValue: homeValue,
        success: false,
        status_code: error?.response?.status,
      });
    }
  };

  // const fetchSliderAmountCalculatorData = async () => {
  //   try {
  //     const { data, status } = await fetchScenarios(scenarioRequestBody);
  //     setScenarios(data.scenarios);
  //     setError(false);
  //     trackAmountCalculatorData('change investment amount', {
  //       homeValue: homeValue,
  //       minMax: minMax,
  //       investmentAmount: investmentAmount,
  //       calculatorInvestmentSize: scenarios[0].investment_amount,
  //       success: true,
  //       status_code: status,
  //     });
  //   } catch (error) {
  //     setError(true);
  //     trackAmountCalculatorData('change investment amount', {
  //       homeValue: homeValue,
  //       success: false,
  //       status_code: error?.response?.status,
  //     });
  //   }
  // };

  // fetch data if query param provided OR if user submits home value.
  useEffect(() => {
    const asyncFetchCalcData = async () => {
      setIsFetchingData(true);
      await fetchAmountCalculatorData();
      setIsFetchingData(false);
    };
    if (homeValue) {
      asyncFetchCalcData();
    }
  }, [homeValue]);

  //   // fetch data if user moves slider
  //   useEffect(() => {
  //     let timeout;
  //     if (investmentAmount) {
  //       setIsFetchingData(true);
  //       timeout = setTimeout(() => {
  //         fetchSliderAmountCalculatorData();
  //         setIsFetchingData(false);
  //       }, 950);
  //     }
  //     return () => clearTimeout(timeout);
  //   }, [investmentAmount]);

  return {
    minMax,
    // scenarios,
    error,
    isFetchingData,
  };
};
